import React from "react";

// Returns an onKeyDown handler that triggers `activate` on Enter or Space —
// matches the native <button> keyboard contract for non-button clickable elements
// (e.g. <div role="button">). preventDefault on Space avoids page scroll.
export function onKeyboardActivate(
    activate: () => void
): (event: React.KeyboardEvent) => void {
    return (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            activate();
        }
    };
}
